import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, ArrowRight, Mail, Phone } from 'lucide-react';

const BookDemoPage: React.FC = () => {
  const openCalendly = () => {
    window.open('https://calendly.com/scinter-support/30min', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl border border-gray-200 p-8 md:p-12"
      >
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <svg className="h-16 w-16" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="35" cy="50" r="22" fill="none" stroke="#8B5CF6" strokeWidth="6"/>
            <circle cx="65" cy="50" r="22" fill="none" stroke="#3B82F6" strokeWidth="6"/>
          </svg>
        </div>

        {/* Content */}
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Access Restricted
          </h1>
          <p className="text-lg text-gray-600 mb-2">
            This application is currently in private beta.
          </p>
          <p className="text-base text-gray-500">
            To get access, please book a demo with our team.
          </p>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-2 gap-4 mb-8">
          <motion.div
            whileHover={{ scale: 1.02 }}
            className="p-4 bg-purple-50 rounded-xl border border-purple-100"
          >
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-purple-600 rounded-lg">
                <Mail className="text-white" size={20} />
              </div>
              <h3 className="font-semibold text-gray-900">Schedule a Demo</h3>
            </div>
            <p className="text-sm text-gray-600">
              Book a 30-minute session to see ScInter in action
            </p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.02 }}
            className="p-4 bg-blue-50 rounded-xl border border-blue-100"
          >
            <div className="flex items-center gap-3 mb-2">
              <div className="p-2 bg-blue-600 rounded-lg">
                <Phone className="text-white" size={20} />
              </div>
              <h3 className="font-semibold text-gray-900">Get Early Access</h3>
            </div>
            <p className="text-sm text-gray-600">
              Learn about our features and get your account set up
            </p>
          </motion.div>
        </div>

        {/* CTA Button */}
        <motion.button
          onClick={openCalendly}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="w-full py-4 px-6 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-semibold rounded-xl shadow-lg flex items-center justify-center gap-3 transition-all"
        >
          <Calendar size={24} />
          <span>Book a Demo on Calendly</span>
          <ArrowRight size={20} />
        </motion.button>

        {/* Footer */}
        <p className="text-center text-sm text-gray-500 mt-6">
          Questions? Contact us at{' '}
          <a href="mailto:support@scinter.org" className="text-purple-600 hover:text-purple-700 font-medium">
            support@scinter.org
          </a>
        </p>
      </motion.div>
    </div>
  );
};

export default BookDemoPage;











